import { useEffect, useState } from "react";
import TabButton from "./TabButton";
import styles from "./TabButtonGroup.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

type TabButtonGroupProps = {
  options: Record<string, string>;
  value: string;
  error: string;
  showErrorMessage: boolean;
  onSelect: (value: string) => void;
  inputName: string;
};

const TabButtonGroup = ({
  options,
  value,
  error,
  showErrorMessage,
  onSelect,
  inputName,
}: TabButtonGroupProps) => {
  const [activeTab, setActiveTab] = useState(value);

  useEffect(() => {
    setActiveTab(value);
  }, [value]);

  return (
    <>
      <div className={styles.buttonGroupSection}>
        {Object.keys(options).map((key, idx) => (
          <TabButton
            index={idx}
            label={options[key]}
            isActive={activeTab === key}
            handleClick={() => {
              setActiveTab(key);
              onSelect(key);
            }}
            inputName={inputName}
          />
        ))}
      </div>
      {showErrorMessage && <div className={styles.errorMessage}>{error}</div>}
    </>
  );
};

export default wrapperHOC(TabButtonGroup, {
  componentName: "TabButtonGroup-BookForm",
  showForChina: true,
});
